<template>
  <div v-infinite-scroll="getEvents"
       class="ypo-events--wrapper"
       :infinite-scroll-distance="2000">
    <v-layout row wrap :class="['ypo-events', 'relative-position', routeConfigHideHeader && 'ypo-events--no-header-layout']">
      <status-overlay :action="fetchingYpoEvents"></status-overlay>      
      <v-flex xs12 row wrap class="ypo-events__title">
       <v-layout>
          <v-flex class="ypo-events__title--label" data-qe-id="ypo-events-title" id="ypo-events-title">
            {{ ypoEventConstant.label.MAIN_TITLE }}
          </v-flex>
          <v-flex
            v-if="filterPillsDesktop"
            class="ypo-events__pills">
              <ypo-events-applied-filter-pills
              :applied-filters="ypoEventsAppliedFilterPills"
              :total-applied-filters-count="totalAppliedFiltersCount"
              :handle-clear="clearAllFilterPills"
              :handle-close="clearSelectedFilterPill">
              </ypo-events-applied-filter-pills>
          </v-flex>
          <v-flex class="ypo-events__result-count"
            v-if="ypoEventsResultCount && ($vuetify.breakpoint.sm || $vuetify.breakpoint.xs)">
            <span data-qe-id="event-result-count" v-if="eventResultCount">
              {{ eventResultCount }}
            </span>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex class="ypo-events__controls-wrapper">
        <v-layout row wrap class="relative-position">
          <div class="blocked-layover" v-if="fetchingYpoEvents && fetchingYpoEvents.pending"></div>
          <v-flex class="ypo-events__result-count">
          <span data-qe-id="event-result-count" v-if="eventResultCount && !(($vuetify.breakpoint.sm || $vuetify.breakpoint.xs))">
            {{ eventResultCount }}</span>
          </v-flex>
          <v-flex xs12 v-if="showLeftPanel">
            <v-layout row class="flex-grow-overwrite-all ypo-events__filter-toggle-wrapper" >
              <v-flex v-if="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs">
                <v-btn class="ypo-events__filter-toggle-btn" @click="toggleMobileFilters">
                  {{filterSortLabel}}
                </v-btn>
              </v-flex>
              <v-flex>
                <v-switch
                    v-model="displayMyEvents"
                    class="ypo-events__toggle"
                    :class="[displayMyEvents ? 'ypo-events__toggle--label' : '']"
                    data-qe-id="my-events-toggle-btn"
                    @change="applyMyEventsFilter"
                    :label="ypoEventConstant.label.MY_EVENTS_TITLE"
                ></v-switch>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 class="filter-selection-area" v-if="showLeftPanel">
            <ypo-events-sort-by :selected-sort-state="ypoEventsSort">
            </ypo-events-sort-by>
            <ypo-event-filters :filter-list="ypoEventsFacets"
                               :set-most-recent-facet-in-state="setMostRecentFacetInState"
                               :selected-filter-state="ypoEventsSelectedFilters"
                               >
            </ypo-event-filters>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex class="ypo-events__results-wrapper" v-if="displayResultSection">
        <v-layout column wrap class="relative-position" >
          <v-layout
              column
              v-if="!ypoEventsResultCount"
              pl-0
              pt-3
              data-qe-id="event-result_no-result"
              class="no-result">
            <v-flex
              class="no-result__label1">
              <span> {{`${ displayMyEvents ? ypoEventConstant.noEventsResults.label1 : ypoEventConstant.noResults.label1}`}}</span>
            </v-flex>
            <v-flex
                class="no-result__label2" >
              <span > {{`${ displayMyEvents ? ypoEventConstant.noEventsResults.label2 : ypoEventConstant.noResults.label2}`}}</span>
              <span class="no-result__label3" @click="applyRecommendedFilter" v-if="displayMyEvents"> {{ypoEventConstant.noEventsResults.label3}}</span>
            </v-flex>
            <v-flex
              xs12
              v-if="ypoEventsAppliedFilterPills && ypoEventsAppliedFilterPills.length && !ypoEventsResultCount"
              class="ypo-events__pills--no-results">
            <ypo-events-applied-filter-pills
                :applied-filters="ypoEventsAppliedFilterPills"
                :total-applied-filters-count="totalAppliedFiltersCount"
                :handle-clear="clearAllFilterPills"
                :handle-close="clearSelectedFilterPill">
            </ypo-events-applied-filter-pills>
          </v-flex>
          </v-layout>
          <v-flex xs12 v-if="ypoEventsList"
                  :class="[ypoEventsAppliedFilterPills && ypoEventsAppliedFilterPills.length ?
                'ypo-events__result--pills' :
                'ypo-events__result']">
            <ypo-events-result :event-list="ypoEventsList" :mobile-app-interface="isMobileAppBrowser"></ypo-events-result>
          </v-flex>
          <v-flex class="loading-more-results">
            <status-overlay :action="fetchingMoreYpoEvents"></status-overlay>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout row wrap class="ypo-events__mobile-filters" v-if="displayMobileFilters">
      <v-flex xs12 class="ypo-events__mobile-filters__controls-top">
        <v-layout row>
          <v-flex xs6 class="ypo-events__mobile-filters__title">{{ypoEventConstant.label.FILTER_SORT}}</v-flex>
          <v-flex xs6 v-if="eventResultCount" class="ypo-events__mobile-filters__count">
            {{eventResultCount}}
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 class="ypo-events__mobile-filters__facets inner-scrollbar">
        <status-overlay :action="fetchingYpoEvents"></status-overlay>
        <ypo-events-applied-filter-pills
            :applied-filters="ypoEventsAppliedFilterPills"
            :total-applied-filters-count="totalAppliedFiltersCount"
            :handle-clear="clearAllFilterPills"
            :handle-close="clearSelectedFilterPill">
        </ypo-events-applied-filter-pills>
        <ypo-events-sort-by :class="[ypoEventsAppliedFilterPills && ypoEventsAppliedFilterPills.length ? '' : 'mt-4']"
        :selected-sort-state="ypoEventsSort">
        </ypo-events-sort-by>
        <ypo-event-filters :filter-list="ypoEventsFacets"
                           :set-most-recent-facet-in-state="setMostRecentFacetInState"
                           :selected-filter-state="ypoEventsSelectedFilters"
                           >
        </ypo-event-filters>
      </v-flex>
      <v-flex xs12 class="ypo-events__mobile-filters__controls-bottom">
        <v-btn class="primary ypo-events__mobile-filters__result-btn"
               @click="toggleMobileFilters"
               data-qe-id="mobile-filter_see-result_btn">
          {{ypoEventConstant.label.SEE_RESULTS}}
        </v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import {
  defaultYpoEventSort,
  ypoEventConstant,
  myChapterEventsOnly,
  filterStateAfterRemovingFilter,
  isMyEventsVisible,
  createMyEventsFilters,
} from "@/components/YpoEvents/ypoEvents.constant";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { storeAction } from "@/store/storeActions.constant";
import { storeMutation } from "@/store/storeMutations.constant";
import { storeGetters } from "@/store/storeGetters.constant";
import YpoEventsAppliedFilterPills from "@/components/YpoEvents/YpoEventsAppliedFilterPills";
import StatusOverlay from "@/components/StatusOverlay/StatusOverlay";
import YpoEventsResult from "@/components/YpoEvents/YpoEventsResult";
import YpoEventFilters from "@/components/YpoEvents/YpoEventFilters";
import YpoEventsSortBy from "@/components/YpoEvents/YpoEventsSortBy";
import { trackPageLoadTime } from '../../common/utils/performance';

export default {
  name: 'YpoEvents',
  components: {
    YpoEventsSortBy,
    YpoEventFilters,
    YpoEventsResult,
    StatusOverlay,
    YpoEventsAppliedFilterPills,
  },
  data() {
    return {
      ypoEventConstant,
      displayMyChapterEventsOnly: false,
      displayMyEvents: false,
    };
  },
  mounted() {
      this.$nextTick(() => {
          trackPageLoadTime('YpoEvents');
      });
  },
  created() {
    const filtersFromRoute = this.$route && this.$route.query && this.$route.query.eventFilters
      ? JSON.parse(this.$route.query.eventFilters)
      : null;
    const searchTextFromRoute = this.$route && this.$route.query && this.$route.query.eventSearchText
      ? this.$route.query.eventSearchText
      : "";
    const searchSortOrder = this.$route && this.$route.query && this.$route.query.sortOrder
      ? JSON.parse(this.$route.query.sortOrder)
      : defaultYpoEventSort;

    this.setYpoEventStateFromRouter({
      eventSearchText: searchTextFromRoute,
      filters: filtersFromRoute,
      sortOrder: searchSortOrder,
    });
    this.displayMyEvents = isMyEventsVisible(filtersFromRoute, this.currentUserId);
    this.getInitialYpoEvents();
  },
  methods: {
    ...mapActions({
      getInitialYpoEvents: `ypoEvents/${storeAction.getInitialYpoEvents}`,
      getMoreYpoEvents: `ypoEvents/${storeAction.getMoreYpoEvents}`,
    }),
    ...mapMutations({
      setYpoEventStateFromRouter: `ypoEvents/${storeMutation.setYpoEventStateFromRouter}`,
      setMostRecentlySelectedFacet: `ypoEvents/${storeMutation.setMostRecentlySelectedFacet}`,
      setMobileFiltersActive: `ypoEvents/${storeMutation.setMobileFiltersActive}`,
    }),
    getEvents() {
      if (this.ypoEventResultOffset && !this.disableYpoEventsInfiniteScroll && this.canFetchMoreResult) {
        this.getMoreYpoEvents();
      }
    },
    setMostRecentFacetInState(facetKey) {
      if (this.setMostRecentlySelectedFacet) this.setMostRecentlySelectedFacet(facetKey);
    },
    clearSelectedFilterPill(filterPill) {
        if (filterPill && filterPill.parentKey) this.setMostRecentFacetInState(filterPill.parentKey);
        const newFilters = filterStateAfterRemovingFilter(this.ypoEventsSelectedFilters, filterPill);
        this.$router.push({
          query: {
            ...this.$route.query,
            eventFilters: JSON.stringify(newFilters),
          },
        });
    },    
    clearAllFilterPills() {
      this.setMostRecentFacetInState();
      this.$router.push('/events');
    },  
    clearHostFilter(ypoEventsSelectedFilters) {     
       ypoEventsSelectedFilters[ypoEventConstant.constant.keys.hostFilter] = [];
        return ypoEventsSelectedFilters;
    },
    applyMyEventsFilter(){
      const filtersFromRoute = this.$route.query.eventFilters ? JSON.parse(this.$route.query.eventFilters) : null;
      this.displayMyEvents = isMyEventsVisible(filtersFromRoute , this.currentUserId);
      const filtersToPush = filtersFromRoute ? { ...filtersFromRoute } : {};
      filtersToPush[ypoEventConstant.constant.keys.hostFilter] = [];
      if (!this.displayMyEvents) {
        filtersToPush[ypoEventConstant.constant.keys.hostFilter] = [
          { ...createMyEventsFilters(this.currentUserId) },
        ];
      }
      if (this.setMostRecentFacetInState) this.setMostRecentFacetInState(ypoEventConstant.constant.keys.hostFilter);
      this.$router.push({
        query: {
          ...this.$route.query,
          eventFilters: JSON.stringify(filtersToPush),
        },
      });
    },
    applyRecommendedFilter() {
      this.$router.push({
        query: {
          ...this.$route.query,
          eventFilters: JSON.stringify({...ypoEventConstant.defaultEventFilters} ),
        },
      });
    },
    applyChapterFilter() {
      const filtersFromRoute = this.$route.query.eventFilters ? JSON.parse(this.$route.query.eventFilters) : null;
      this.displayMyChapterEventsOnly = myChapterEventsOnly(filtersFromRoute);
      const filtersToPush = filtersFromRoute ? { ...filtersFromRoute } : {};
      filtersToPush[ypoEventConstant.constant.keys.hostFilter] = [];
      if (!this.displayMyChapterEventsOnly) {
        filtersToPush[ypoEventConstant.constant.keys.hostFilter] = [
          { ...ypoEventConstant.constant.myChapterDefaultFilter },
        ];
      }
      if (this.setMostRecentFacetInState) this.setMostRecentFacetInState(ypoEventConstant.constant.keys.hostFilter);
      this.$router.push({
        query: {
          ...this.$route.query,
          eventFilters: JSON.stringify(filtersToPush),
        },
      });
    },
    toggleMobileFilters() {
      if (this.setMobileFiltersActive) this.setMobileFiltersActive();
    },
  },
  computed: {
    ...mapState('actionState', ['actions']),
    ...mapGetters({
      ypoEventsList: `ypoEvents/${storeGetters.ypoEventsList}`,
      ypoEventsResultCount: `ypoEvents/${storeGetters.ypoEventsResultCount}`,
      ypoEventsFacets: `ypoEvents/${storeGetters.ypoEventsFacets}`,
      ypoEventsSelectedFilters: `ypoEvents/${storeGetters.ypoEventsSelectedFilters}`,
      ypoEventsAppliedFilterPills: `ypoEvents/${storeGetters.ypoEventsAppliedFilterPills}`,
      ypoEventsSort: `ypoEvents/${storeGetters.ypoEventsSort}`,
      disableYpoEventsInfiniteScroll: `ypoEvents/${storeGetters.disableYpoEventsInfiniteScroll}`,
      ypoEventResultOffset: `ypoEvents/${storeGetters.ypoEventResultOffset}`,
      canFetchMoreResult: `ypoEvents/${storeGetters.canFetchMoreResult}`,
      mobileFiltersActive: `ypoEvents/${storeGetters.mobileFiltersActive}`,
      isMobileAppBrowser: `${[storeGetters.isMobileAppBrowser]}`,
      routeConfigHideHeader: `${[storeGetters.routeConfigHideHeader]}`,
      currentUserId: `memberProfile/${storeGetters.currentUserId}`,
    }),
    
    fetchingYpoEvents() {
      return this.actions[storeAction.getInitialYpoEvents];
    },
    fetchingMoreYpoEvents() {
      return this.actions[storeAction.getMoreYpoEvents];
    },    
    showLeftPanel() {
      let result = false;
      if (!(this.fetchingYpoEvents && this.fetchingYpoEvents.pending) && !(this.fetchingMoreYpoEvents && this.fetchingMoreYpoEvents.pending)) {
        result = true;
      }
      return result;      
    },
    eventResultCount() {
      let resultCount = '';      
      if (this.ypoEventsResultCount) {
        resultCount = this.ypoEventsResultCount === 1
        ? `${this.ypoEventsResultCount} Event Result`
        : `${this.ypoEventsResultCount} Event Results`;
      }
      return resultCount;
    },
    totalAppliedFiltersCount() {
      let result = 0;
      if (this.ypoEventsSelectedFilters && Object.keys(this.ypoEventsSelectedFilters).length) {
        Object.keys(this.ypoEventsSelectedFilters).forEach((key) => {
          result += this.ypoEventsSelectedFilters[key].length;
        });
      }
      return result;
    },
    filterPillsDesktop() {
      return this.ypoEventsAppliedFilterPills && this.ypoEventsAppliedFilterPills.length && this.ypoEventsResultCount && 
      !(this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs);
    },
    filterSortLabel() {
      return this.ypoEventsAppliedFilterPills && this.ypoEventsAppliedFilterPills.length
          ? `${ypoEventConstant.label.FILTER_SORT} (${this.ypoEventsAppliedFilterPills.length})`
          : ypoEventConstant.label.FILTER_SORT;
    },
    displayMobileFilters() {
      return this.mobileFiltersActive && (this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs);
    },
    displayResultSection() {
      let result = true;
      if (this.mobileFiltersActive && (this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs)) {
        result = false;
      }
      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../common/styles/_colors.scss';
@import '../../common/styles/_responsive.scss';

.ypo-events--wrapper {
  background-color: $white;
}

.ypo-events {
  position: relative;
  min-height: 350px;
  max-width: 2200px;
  margin: 55px auto 0;
  background-color: $white;
  padding: 0 15px 0 10px;

  @include breakpointMin(sm) {
    padding: 0 30px 0 30px;
    margin-top: 63px;
  }

  @include breakpointMin(md) {
    padding-left: 40px;
  }

  @include breakpointMin(lg) {
    padding-left: 50px;
    padding-right: 15px;
  }

  @include breakpointMin(xl) {
    padding-right: 0;
  }

  @include breakpointMin(xxl) {
    padding-left: 88px;
  }

  &__controls-wrapper {
    width: 100%;
    max-width: 100%;
    flex-basis: 100%;
    padding: 5px 26px 0 5px;
    position: fixed;
    z-index: 3;
    background-color: white;
    box-shadow: 0 0 0 2px rgba(255,255,255,0.5);

    @include breakpointMin(xs) {      
      margin-top: 45px;
      padding-bottom: 10px;
    }

    @include breakpointMin(sm) {
      width: calc(100% - 46px);
      max-width: calc(100% - 46px);
      padding-left: 13px; 
      margin-top:50px;     
    }

    @include breakpointMin(md) {
      top: 0; 
      bottom: 20px; 
      overflow-y: auto;
      max-width: 275px;
      position: fixed;
      padding: 0;
      margin-top:150px;
    }
  }

  &__mobile-filters {
    position: absolute;
    z-index: 100;
    left: 0;
    top: 0;
    background-color: $white;
    width: 100%;
    height: 100%;

    &__controls-top {
      height: 56px;
      padding: 15px;
      position: fixed;
      background-color: $white;
      top: 0;
      z-index: 2;
      width: 100%;
      border-bottom: 2px solid $ypo-solitude-gray;
    }

    &__controls-bottom {
      height: 56px;
      position: fixed;
      bottom: 0;
      width: 100%;
      background-color: $white;
      padding: 8px 15px 0 0 ;
      border-top: 2px solid $ypo-solitude-gray;
      text-align: right;
    }

    &__facets {
      position: relative;
      padding-left: 15px;
      padding-bottom: 10px;
      height: calc(100% - 112px);
      margin-top: 55px;
      overflow: auto;
    }

    &__title {
      font-size: 18px;
      font-family: 'Raleway', sans-serif;
      color: $ypo-blue;
    }

    &__count {
      font-size: 12px;
      color: $ypo-blue;
      text-align: right;
      line-height: 30px;
    }

    &__result-btn {
      height: 36px;
      width: 171px;
      margin: 0 !important;
    }

    .filter-pills-list {
      padding-left: 0;
    }
  }

  &__filter-toggle-wrapper {
    justify-content: space-between;    
     @include breakpointMin(sm) {
      justify-content: normal;
    }
  }

  &__results-wrapper {
    margin-top: 115px;
    padding-left: 5px;

    @include breakpointMin(xs) {
      margin-top: 120px;
    }

     @include breakpointMin(sm) {
      margin-top: 120px;
    }

    @include breakpointMin(md) {
      max-width: calc(100% - 275px);
      margin-top: 95px;
      margin-left: 280px;
    }
  }

  &__title {
    position: fixed;   
    background-color: $white;
    top: 63px;
    z-index: 5;  
    width: 100%;
    max-width: 100%;
    flex-basis: 100%;

    @include breakpointMin(xs) {
      box-shadow: 0 0 0 2px rgba(255,255,255,0.5); 
      top: 55px;
      height: 45px;
    }

    @include breakpointMin(sm) {      
      padding: 0 13px 0 7px;
      top: 63px;
      height: 50px;
    }

    @include breakpointMin(md) {
      padding: 0 !important; 
      top: 63px;
      height: auto;
      min-height: 80px;
      box-shadow: 0 0 0 2px rgba(255,255,255,0.5);
    }
    
    &--label {
    padding: 10px 0 15px;
    color: $ypo-blue;
    font-family: 'Raleway', sans-serif;
    font-size: 18px;
    font-weight: 500;
    max-width: 100%;

      @include breakpointMin(xs) {
        padding-left: 5px;
        padding-bottom: 5px;
      }

      @include breakpointMin(md) {
        font-size: 30px;
        max-width: 275px;
        padding-top: 15px;
        padding-left: 0;
      }
  }
  }

  &__result-count {
    font-size: 16px;
    color: $ypo-cod-gray;
    height: auto;
    margin-top: 0;
    padding: 0 0 25px 0;
    max-width: 50%;
    text-align: left;
    line-height: 22px;
    letter-spacing: 0;

    @include breakpointMin(xs) {
      font-size: 12px;
      text-align: right;
      padding: 15px 10px 8px 0;
      background-color: white;
      margin-right: 10px;
    }
   
    @include breakpointMin(sm) {
      padding: 15px 0;
      margin-right: 0;
    }

    @include breakpointMin(md) {
      max-width: 100%;;
      font-size: 16px;
      padding: 0 0 25px 2px;
      text-align: left;     
    }
  }

  &__pills {
    background-color: $white; 
    width: 0;
  }

  &__pills--no-results {
    margin-top: 0;

    > div {
      padding-left: 0;
    }
  }

  &__result {
    @include breakpoint(sm) {
      margin-top: 10px;
    }
  }

  &__result--pills {
    margin-top: 0;
    @include breakpoint(sm) {
      padding: 0;
    } 
    @include breakpointMin(xs) {
      padding: 0;
      margin-top: 10px;   
    }    
    @include breakpointMin(sm) {
      padding: 0;
    } 
     @include breakpointMin(md) {
      padding: 0;
    }   
  }
  
  &__filter-toggle-btn {
    background-color: $white !important;
    border: 1px solid $ypo-gray !important;
    box-shadow: none !important;
    color: $ypo-blue !important;
    padding: 10px;
    font-size: 11px;
    margin: 0 !important;

    @include breakpointMin(xs) {
      font-size: 12px;
    }
  }

  &__toggle {
    margin-top: 2px;

    @include breakpointMin(sm) {
      margin-left: 20px;
    }

    @include breakpointMin(md) {
      margin: 0;
    }
  }

  .no-result {
    margin-top: 0;
    color: $ypo-blue;   

    &__label1 {
      font-size: 18px;
      line-height: 21px;
      font-weight: bold;
      font-family: 'Raleway', sans-serif;
      max-height: 21px;

      @include breakpointMin(xs) {
      max-height: 41px;
      }

      @include breakpointMin(sm) {
      max-height: 21px;
      }
    }
    &__label2 {
      padding-top: 12px;
      font-size: 14px;
      line-height: 16px;
      font-family: 'Raleway', sans-serif;
      max-height: 21px;
    }
    &__label3 {
      text-decoration: underline;
      cursor: pointer;
      padding: 12px 0;
    }
  }

  .filter-selection-area {
    @include breakpoint(sm) {
      display: none;
    }
  }

  .loading-more-results {
    position: relative;
    height: 150px;
  }

  &--no-header-layout {
    @include breakpoint(sm) {
      margin-top: 0;
      .ypo-events__title {
        top: 0;
      }
    }
  }
}
</style>

<style lang="scss">
@import '../../common/styles/_responsive.scss';

.ypo-events {
  padding-top: 15px;

  @include breakpointMin(md) {
    padding-top: 0;
  }

  &__toggle {
    .v-label {
    font-size: 11px !important;
    font-weight: normal;
    @include breakpointMin(xs) {
      font-size: 12px !important;
    }

    @include breakpointMin(md) {
      font-size: 14px !important;
      }
    }

    &--label {
      .v-label {
      font-weight: bold;
      }
    }
  }

  &__mobile-filters {
    .v-expansion-panel__container {
      padding-left: 5px;
    }
  }

  .v-input--switch__track {
    height: 26px !important;
    width: 43px !important;
    border: 1px solid $ypo-silver !important;
    border-radius: 13px !important;
    color: white;
    box-shadow: inset 0 1px 5px 0 rgba(0,0,0,0.52) !important;
    opacity: 1  !important;
    top: 0;
    right: 0;
    left: 0;
  }

  .accent--text {
    color: $ypo-green-toggle !important;
    caret-color: $ypo-green-toggle !important;
  }

  .v-input--switch__thumb {
    height: 24px !important;
    width: 24px !important;
    border: 1px solid $ypo-grimmy-grey !important;
    color: white !important;
    top: 0.5px;
    right: 0;
    left: 0;
    box-shadow: none !important;
  }

  .v-input--selection-controls__input {
    width: 43px !important;
  }

  .v-input--selection-controls__ripple {
    display: none;
  }

  .v-messages {
    display: none;
  }

  .v-input--switch.v-input--is-dirty .v-input--selection-controls__ripple,
  .v-input--switch.v-input--is-dirty .v-input--switch__thumb {
    -webkit-transform: translate(18px, 0);
    transform: translate(18px, 0);
  }
}

.menuable__content__active {
  z-index: 200 !important;
}
</style>
